<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import {
  SectionHeading,
  SectionHeadingLine
} from '@toni/brand-ui'

import RelatedArticles from './base/RelatedArticles.vue'

defineProps<{
    id: string
  }>()

const { t } = useI18n()
</script>

<template>
  <RelatedArticles :id="id">
    <template #headline>
      <SectionHeadingLine class="w-[72px] h-[6px] mb-[6px] sm:mb-2 sm:w-[88px] sm:h-2 md:w-[88px] md:h-2 lg:w-[124px] lg:h-2.5 xl:w-[124px] xl:h-2.5 max-w-[124px] max-h-[10px]" />
      <SectionHeading class="text-heading-display-xxs sm:text-heading-display-xs md:text-heading-display-xs lg:text-heading-display-sm">
        {{ t('teaser.related.headline') }}
      </SectionHeading>
    </template>
  </RelatedArticles>
</template>
